"use client"

import * as React from "react"
import { Link } from "react-router-dom"
import {
  Users,
  Shield,
  FileText,
  Gift,
  UserPlus,
  BookOpen,
  Dumbbell,
  TrendingUp,
  Settings,
  LayoutDashboard,
  Building2,
} from "lucide-react"

import { NavMain } from "./nav-main"
import { NavUser } from "./nav-user"
import { SCOPE, usePermissions } from "@app/permissions"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@mehir/web-ui/sidebar"

const data = {
  navMain: [
    {
      title: "Dashboard",
      url: "/",
      icon: LayoutDashboard,
    },
    {
      title: "RBAC",
      url: "#",
      icon: Shield,
      items: [
        {
          title: "Roller",
          url: "/rbac/roles",
          requirement: { module: 'Backoffice', subModule: 'RolePermission', scope: SCOPE.view },
        },
        {
          title: "Sistem Kullanıcıları",
          url: "/rbac/system-users",
          requirement: { module: 'Backoffice', subModule: 'Users', scope: SCOPE.view },
        },
        {
          title: "Denetim Kayıtları",
          url: "/rbac/audit-logs",
          requirement: { module: 'Backoffice', subModule: 'Users', scope: SCOPE.view },
        },
      ],
    },
    {
      title: "Kullanıcılar",
      url: "/users/list",
      requirement: { module: 'Auth' },
      icon: Users,
    },
    {
      title: "Sözleşmeler",
      url: "#",
      icon: FileText,
      items: [
        {
          title: "Mehir Sözleşmeleri",
          url: "/contracts/list",
          requirement: { module: 'Contract', subModule: 'Contract', scope: SCOPE.view },
        },
        {
          // Disabled: page is currently a duplicate of the contracts list
          // (same endpoint, same data). Re-enable once backend ships either a
          // dedicated savings-plan list endpoint or a summary include on the
          // contracts list.
          title: "Birikim Planları",
          url: "/contracts/savings-plans",
          requirement: { module: 'Contract', subModule: 'Contract', scope: SCOPE.view },
          disabled: true,
        },
      ],
    },
    {
      title: "Kampanyalar",
      url: "#",
      icon: Gift,
      items: [
        {
          title: "Kampanya Listesi",
          url: "/campaigns/list",
          requirement: { module: 'Campaign', subModule: 'Campaign', scope: SCOPE.view },
        },
        {
          title: "Yeni Kampanya",
          url: "/campaigns/new",
          requirement: { module: 'Campaign', subModule: 'Campaign', scope: SCOPE.create },
        },
      ],
    },
    {
      title: "Davetler",
      url: "#",
      icon: UserPlus,
      items: [
        {
          title: "Davet Listesi",
          url: "/referrals/list",
          requirement: { module: 'Auth' },
        },
        {
          title: "Manuel Ödeme",
          url: "/referrals/manual-payment",
          // Manuel ödeme sözleşme servisi üzerinden yürüyor.
          disabled: true,
          requirement: { module: 'Auth' },
        },
        {
          title: "Kullanıcı Hakedişleri",
          url: "/referrals/earnings",
          requirement: { module: 'Auth' },
        },
      ],
    },
          {
            title: "İçerik",
            url: "#",
            icon: BookOpen,
            items: [
              {
                title: "Blog Yazıları",
                url: "/content/blog/list",
                requirement: { module: 'Blog', subModule: 'Blog', scope: SCOPE.view },
              },
              {
                title: "Ana Sayfa Önceliklendirme",
                url: "/content/blog/featured",
                requirement: { module: 'Blog', subModule: 'Blog', scope: SCOPE.update },
              },
              {
                title: "Bizden Haberler",
                url: "/content/news/list",
                requirement: { module: 'Blog', subModule: 'Announcement', scope: SCOPE.view },
              },
            ],
          },
    {
      title: "Fit",
      url: "#",
      icon: Dumbbell,
      items: [
        {
          title: "Video Listesi",
          url: "/fit/videos",
          requirement: { module: 'Fit', subModule: 'Exercise', scope: SCOPE.view },
        },
        {
          title: "Antrenman Listesi",
          url: "/fit/exercises",
          requirement: { module: 'Fit', subModule: 'Exercise', scope: SCOPE.view },
        },
        {
          title: "Kullanıcı Antrenmanları",
          url: "/fit/user-exercises",
          // Kullanıcı antrenman API'si backoffice için henüz yok.
          disabled: true,
          requirement: { module: 'Fit', subModule: 'Exercise', scope: SCOPE.view },
        },
        {
          title: "Hedefler",
          url: "/fit/targets",
          requirement: { module: 'Fit', subModule: 'Exercise', scope: SCOPE.view },
        },
        {
          title: "Seviyeler",
          url: "/fit/levels",
          requirement: { module: 'Fit', subModule: 'Exercise', scope: SCOPE.view },
        },
        {
          title: "Egzersiz Tipleri",
          url: "/fit/exercise-types",
          requirement: { module: 'Fit', subModule: 'Exercise', scope: SCOPE.view },
        },
      ],
    },
    {
      title: "Finans",
      url: "#",
      icon: TrendingUp,
      items: [
        {
          title: "İstatistikler",
          url: "/finance/statistics",
          requirement: { module: 'Finance' },
        },
        {
          // Temporarily disabled per request.
          title: "Haber Yönetimi",
          url: "/finance/news-management",
          requirement: { module: 'Finance' },
          disabled: true,
        },
      ],
    },
    {
      title: "Ayarlar",
      url: "#",
      icon: Settings,
      items: [
        {
          title: "Push Notification",
          url: "/settings/push-notification",
          // Push bildirim API'si backoffice için henüz yok.
          disabled: true,
          requirement: { module: 'Auth' },
        },
        {
          title: "İletişim İzinleri",
          url: "/settings/communication-permissions",
          requirement: { module: 'Auth' },
        },
        {
          title: "FAQ Kategorileri",
          url: "/settings/faq-categories",
          requirement: { module: 'Blog', subModule: 'Faq', scope: SCOPE.view },
        },
        {
          title: "FAQ Yönetimi",
          url: "/settings/faq-management",
          requirement: { module: 'Blog', subModule: 'Faq', scope: SCOPE.view },
        },
        {
          title: "Sözleşmeler",
          url: "/settings/app-contracts",
          requirement: { module: 'Blog', subModule: 'AppContracts', scope: SCOPE.view },
        },
        {
          title: "Sürüm Notları",
          url: "/changelog",
        },
        {
          title: "İletişim Bilgileri",
          url: "/settings/contact-info",
          requirement: { module: 'Blog', subModule: 'ContactInfo', scope: SCOPE.view },
        },
      ],
    },
  ],
}

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { can } = usePermissions()

  // Hide what the signed-in user cannot open. Sections whose children are all
  // hidden disappear with them, and a section with no children of its own is
  // judged on its own requirement.
  const navMain = React.useMemo(
    () =>
      data.navMain
        .map((item) => ({
          ...item,
          items: item.items?.filter((subItem) => can(subItem.requirement)),
        }))
        .filter((item) =>
          item.items ? item.items.length > 0 : can(item.requirement)
        ),
    [can]
  )

  return (
    <Sidebar variant="inset" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" asChild>
              <Link to="/">
                <div className="bg-sidebar-primary text-sidebar-primary-foreground flex aspect-square size-8 items-center justify-center rounded-lg">
                  <Building2 className="size-4" />
                </div>
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <span className="truncate font-medium">Mehir Backoffice</span>
                  <span className="truncate text-xs">Admin Panel</span>
                </div>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={navMain} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  )
}

